import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  icon
}) => {
  const { getThemeStyles } = useTheme();
  const themeStyles = getThemeStyles();

  return (
    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
      <h1 style={{
        color: themeStyles.primary,
        marginBottom: description ? '10px' : '0',
        fontSize: '2.5rem'
      }}>
        {icon && <span style={{ marginRight: '10px' }}>{icon}</span>}
        {title}
      </h1>
      {description && (
        <p style={{ color: themeStyles.textSecondary }}>
          {description}
        </p>
      )}
    </div>
  );
};

export default PageHeader;